import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import IcomoonReact from 'icomoon-react';

import WebcamCapture from '../components/presentational/WebcamCapture';
import iconSet from '../../../shared/images/teambuildr-selection.json';

import useFeed from '../components/hooks/useFeed';

const CloseButtonContainer = styled('div')`
  display: flex;
  justify-content: end;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 100;
`;

const InnerFormikWrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  position: relative;
`;

const ModalWrapper = styled('div')`
  display: flex;
  width: 100%;
`;

const RecordVideoModal = ({ onRequestClose }) => {
  const { handleUploadMedia } = useFeed();

  const handleSubmit = (values, { setSubmitting }) => {
    setTimeout(() => {
      setSubmitting(false);
    });
  };

  return (
    <ModalWrapper>
      <Formik
        initialValues={{}}
        onSubmit={handleSubmit}
      >
        {() => (
          <InnerFormikWrapper>
            <CloseButtonContainer onClick={onRequestClose}>
              <IcomoonReact
                iconSet={iconSet}
                color='#444444'
                size={10}
                icon='remove'
              />
            </CloseButtonContainer>
            <WebcamCapture handleUploadMedia={handleUploadMedia} />
          </InnerFormikWrapper>
        )}
      </Formik>
    </ModalWrapper>
  );
};

RecordVideoModal.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
};

export default RecordVideoModal;
